import { useSearch } from '@honeycomb/data';
// The trip type from useSearch defaults to holiday until it is known.
// This can lead to us to incorrectly display holiday related UI until we know the true trip type.
// We will return null until other parameters have been confirmed and we know the TripType is correct.
export const useTripTypeFromTrip = () => {
    const [searchParameters] = useSearch([]);
    const hasDate = searchParameters.startDate || searchParameters.wholeMonthStartDate;
    return (hasDate ? searchParameters.tripType : null) || null;
};
